import { useQuery } from '@tanstack/react-query';

import { apiCall, apiClient } from 'shared/client/apiClient';

export const latestLearningActivitySnapshotIdQueryKey = ({
  learningActivityDraftId,
  publishedOnly
}: {
  learningActivityDraftId?: string;
  publishedOnly?: boolean;
}) =>
  [
    'learning-activity-snapshot',
    'latest-id',
    { learningActivityDraftId, ...(publishedOnly && { publishedOnly }) }
  ] as const;

export const getLatestLearningActivitySnapshotId = async ({
  learningActivityDraftId,
  publishedOnly
}: {
  learningActivityDraftId: string;
  publishedOnly?: boolean;
}) => {
  return apiCall(
    apiClient.GET('/learning-activity-snapshots/latest-id', {
      params: {
        query: {
          learningActivityDraftId,
          ...(publishedOnly && { publishedOnly: 'true' })
        }
      }
    })
  );
};

export const useGetLatestLearningActivitySnapshotIdQuery = ({
  enabled,
  learningActivityDraftId,
  publishedOnly
}: {
  enabled?: boolean;
  learningActivityDraftId?: string;
  publishedOnly?: boolean;
}) => {
  return useQuery({
    queryKey: latestLearningActivitySnapshotIdQueryKey({ learningActivityDraftId, publishedOnly }),
    queryFn: () =>
      getLatestLearningActivitySnapshotId({
        learningActivityDraftId: learningActivityDraftId as string,
        publishedOnly
      }),
    enabled: !!learningActivityDraftId && enabled !== false
  });
};
